import type { OrderRecord } from "@/api/types";

/** Newest N days; 0 is all time. */
export type OrderDaysFilter = 0 | 1 | 7 | 30;

export type OrderFilters = {
  symbol: string;
  days: OrderDaysFilter;
  backtestId: string;
};

export const NO_FILTERS: OrderFilters = { symbol: "", days: 0, backtestId: "" };

/** Orders that filled on an exchange and pass the filters, newest first as given. */
export function filterExchangeOrders(orders: OrderRecord[], f: OrderFilters, now = Date.now()): OrderRecord[] {
  const since = f.days ? now - f.days * 86_400_000 : 0;
  return orders.filter((o) => {
    if (o.status !== "done") return false;
    if (f.symbol && o.symbol !== f.symbol) return false;
    if (f.backtestId && (f.backtestId === "none" ? Boolean(o.backtest_id) : o.backtest_id !== f.backtestId)) return false;
    if (since && !(Date.parse(o.created_at) >= since)) return false;
    return true;
  });
}

/** Symbols of the filled orders given, most orders first. */
export function exchangeOrderSymbols(orders: OrderRecord[]): { symbol: string; count: number }[] {
  const counts = new Map<string, number>();
  for (const o of orders) if (o.status === "done") counts.set(o.symbol, (counts.get(o.symbol) || 0) + 1);
  return [...counts].map(([symbol, count]) => ({ symbol, count })).sort((a, b) => b.count - a.count || a.symbol.localeCompare(b.symbol));
}
